<template>
  <div class="list-faq" v-bind:class="{clickable: clickable}" @click="onClick">
    <div class="faq-accordion">
        <div class="faq-accordion-header">
            <div class="faq-q-icon">Q</div>
            <div class="faq-q-header">
                <p class="faq-q-text">{{ text }}</p>
            </div>
            <div class="faq-indicator"></div>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ListFAQ',
    props: {
      text: {
        type: String,
        default: function () {
          return ''
        }
      },
      urlName: {
        type: String,
        default: function () {
          return ''
        }
      }
    },
    methods: {
      onClick: function () {
        if (this.url !== '') {
          setTimeout(() => {
            this.$router.push({name: this.urlName})
          }, 300)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../node_modules/hotcss/src/px2rem.scss";
  @import "../assets/style/settings.scss";
  @import "../assets/style/flex.scss";
  @import "../assets/style/faq.scss";

  .clickable {
    &:active {
      background: #f1f1f1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ListFAQ.vue